import React from 'react';
import PanelContable from './PanelContable';

export default function Contable() {
  return (
    <div className="page" style={{ overflow: 'hidden' }}>
      <PanelContable embedded />
    </div>
  );
}
